import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { Dialog, DialogActionsBar } from '@progress/kendo-react-dialogs';
import { useTranslation } from 'react-i18next';
import { InputAdornment, TextField, Tooltip } from '@material-ui/core';
import { InfoCircle } from 'styled-icons/boxicons-regular';
import { Autocomplete } from '@material-ui/lab';
import { useSelector, useDispatch } from 'react-redux';
import { Close } from 'styled-icons/evaicons-solid';
import { CloudUploadFill, ArrowUpRight } from 'styled-icons/bootstrap';
import { v4 } from 'uuid';
import { storage } from '../../../system/model/firebase/firebase';
import UserDefault from '../../../system/access/images/perfil_default.jpg';
import { palette } from '../../../system/styles/styles';
import { addUser, updateUser } from '../../../redux/actions/company_action';

const MainContainer = styled.main`
  .k-window-content,
  .k-prompt-container {
    padding: 0;
    border-radius: 10px;
  }
  .k-dialog-wrapper {
    z-index: 1;
  }
  .k-dialog-wrapper .k-dialog {
    border-radius: 10px;
  }
  .cbx-Pop {
    z-index: 100000 !important;
  }
  .cbx_persolnal {
    font-size: 14px;
    font-family: ${palette.nereg};

    span label input button option {
      font-size: 14px;
      font-family: ${palette.nereg};
    }
  }
  .header {
    height: 50px;
    width: calc(98% - 1px);
    align-items: center;
    justify-content: space-between;
    display: flex;
    flex-direction: row;
    position: relative;
    border-bottom: 1px solid ${palette.black};
    background-color: #1d1d38;
    border-top-left-radius: 8px;
    border-top-right-radius: 8px;
    padding-left: 16px;

    button {
      background-color: #1d1d38 !important;
      color: #fff;
      box-shadow: none;
      border: none;
    }

    h1 {
      font-size: 16px;
      text-align: center;
      color: #fff;
    }
  }

  .containerBody {
    width: 50vw;
    height: 70vh;
    border-radius: 10px;
    .body_Modal {
      overflow: auto;
      height: 87%;
      padding: 10px;
    }
  }
  .k-dialog-buttongroup {
    display: grid;
    grid-template-columns: 50% 50%;
    button {
      width: 50%;
      justify-self: center;
      height: 35px;
      cursor: pointer;
      font-family: ${palette.nereg};
      font-size: 18px;
    }
    .cancel {
      background: none;
      border: none;
      font-weight: 400;
      color: ${palette.red};
    }
    .save {
      background: none;
      border: none;
      font-weight: 400;
      background-color: ${palette.blue};
      color: ${palette.white};
      border-radius: 10px;
    }
  }

  .user_container {
    width: 100%;
    height: 100%;
    display: grid;
    grid-gap: 32px;
    justify-items: center;
    .boxdiv {
      width: 50%;
      display: flex;
      flex-direction: column;
      &:nth-child(1) {
        img {
          border-radius: 50%;
          width: 100px;
          height: 100px;
          object-fit: cover;
          object-position: center;
          margin: auto;
        }
        .w100 {
          width: 100% !important;
        }
        .bottom_upload {
          background-color: ${palette.blue};
          width: 40%;
          border-radius: 8px;
          margin: 15px auto 0 auto;
          //margin-top: 15px;
          box-shadow: ${palette.lightBS};
          display: grid;
          //grid-gap: 32px;
          padding: 6px;
          //grid-template-columns: 20% 80%;
          font-size: 14px;
          font-family: ${palette.nereg};
          color: #ffffff;
          text-align: center;
          span {
            font-size: 14px;
            font-family: ${palette.nereg};
            color: #ffffff;
          }
        }
      }
    }

    .form_user {
      padding: 16px;
      height: 100%;
      display: grid;
      gap: 10px;
      width: 96%;
      &::-webkit-scrollbar {
        width: 1em;
        height: 1em;
      }

      &::-webkit-scrollbar-track {
        background-color: #f2f2f2;
      }

      &::-webkit-scrollbar-thumb {
        background-color: #ccc;
        border-radius: 0.1rem;
      }

      label {
        font-size: 16px;
        font-family: ${palette.nereg};
        color: ${palette.black};
        text-align: start;
      }
    }
  }
`;

const ModalEditUser = (props) => {
  const { user, toggleModal } = props;
  const { t } = useTranslation(['admin']);
  const dispatch = useDispatch();
  // const typeUser = useSelector((state) => state.auth.claims.typeuser);
  const idcompany = useSelector((state) => state.auth.uid);
  const [state, setState] = React.useState({
    names: '',
    lastNames: '',
    phoneNumber: '',
    email: '',
    slack: '',
    type: '',
    department: 'Departamento',
    ToggleRol: false,
    ToggleDelete: false,
    modal_status_Add: false,
    imageProfile: UserDefault,
    iduserEdit: null,
    isUploading: false,
    progress: 0,
    levelPermission: 2,
    changePassword: true,
  });
  React.useEffect(() => {
    if (user) {
      setState((prev) => ({
        ...prev,
        ...user,
        iduserEdit: user.id,
        levelPermission: 2,
      }));
    }
  }, []);
  const onSave = () => {
    if (state?.iduserEdit) {
      const {
        names,
        lastNames,
        phoneNumber,
        levelPermission,
        email,
        imageProfile,
        iduserEdit: id,
        changePassword,
      } = state;
      dispatch(
        updateUser({
          names,
          lastNames,
          phoneNumber,
          levelPermission,
          email,
          imageProfile,
          id,
          changePassword,
          userProfile: '',
          objectID: idcompany,
          color: `#${  ((Math.random() * 0xffffff) << 0).toString(16).padStart(6, '0')}`,
        })
      );
    } else {
      const { names, lastNames, phoneNumber, levelPermission, email, imageProfile, changePassword } = state;
      dispatch(
        addUser({
          names,
          lastNames,
          phoneNumber,
          levelPermission,
          email,
          imageProfile,
          changePassword,
          userProfile: '',
          objectID: idcompany,
          color: `#${  ((Math.random() * 0xffffff) << 0).toString(16).padStart(6, '0')}`,
        })
      );
    }
    toggleModal();
  };
  const OnChange = async (e) => {
    const { name, value } = e.target;
    await setState((prevState) => ({ ...prevState, [name]: value }));
  };
  // const setTypeUsers = () => {
  //   return [t('User'), t('Recruiter'), 'admin'];
  // };
  // const TypeUsers = setTypeUsers();
  // const textData = () => {
  //   const { levelPermission } = state;
  //   switch (levelPermission) {
  //     case 2:
  //       return t('adminType');
  //     case 1:
  //       return t('recruiterType');
  //     case 0:
  //       return t('userType');
  //     default:
  //       return '';
  //   }
  // };
  const onClear = () => {
    setState((prevState) => ({
      ...prevState,
      names: '',
      lastNames: '',
      phoneNumber: '',
      email: '',
      department: 'Departamento',
      ToggleRol: false,
      ToggleDelete: false,
      imageProfile: UserDefault,
      iduserEdit: null,
      levelPermission: 0,
      changePassword: true,
    }));
  };
  // Métdoo para eliminar Imagenes del storage
  const deleteCVStorage = async (name) => {
    try {
      if (name) {
        await storage.ref(name).delete();
      }
    } catch (e) {
      console.error(e);
    }
  };
  const updloadImage = async (even) => {
    const name = `profile/${idcompany}/${v4()}`;
    const updaload = storage.ref(name).put(even?.target?.files[0]);
    updaload.then(() => {
      if (state?.imgName) {
        deleteCVStorage(state?.imgName);
      }
      updaload.snapshot.ref.getDownloadURL().then((url) => {
        setState((prevState) => ({ ...prevState, imageProfile: url, imgName: name }));
      });
    });
  };

  const getRender = () => {
    return (
      <div className="bottom_upload">
        <div>
          <label htmlFor="upLoadfiles">
            <span style={{ cursor: 'pointer' }}>
              {t('UploadAPhoto')} <CloudUploadFill size="24" className="backup-icon" />
            </span>
          </label>
          <input
            type="file"
            id="upLoadfiles"
            name="imageProfile"
            accept=".jpg,.png,.jpeg"
            style={{ display: 'none' }}
            onChange={updloadImage}
          />
        </div>
      </div>
    );
  };

  return (
    <MainContainer>
      <Dialog>
        <section className="containerBody">
          <div className="header">
            <h1>{t('AddUser')}</h1>
            <div
              className="header--closed"
              onClick={() => {
                onClear();
                toggleModal();
              }}>
              <button type="button">
                <Close color="#FFF" size={30} />
              </button>
            </div>
          </div>
          <div className="body_Modal">
            <div className="user_container">
              <div className="boxdiv">
                <img src={state.imageProfile} alt="Imagen de Usuario" />
                {getRender()}
              </div>

              <div className="form_user">
                <label>{t('Name')}</label>
                <TextField
                  type="text"
                  name="names"
                  placeholder={t('placeholderName')}
                  onChange={OnChange}
                  value={state.names}
                  variant="outlined"
                  style={{ width: '100%' }}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="start">
                        <Tooltip title="Nombre del Usuario" arrow>
                          <InfoCircle size="20" color={palette.grayNew} />
                        </Tooltip>
                      </InputAdornment>
                    ),
                  }}
                />

                <label>{t('LastName')}</label>
                <TextField
                  type="text"
                  name="lastNames"
                  placeholder={t('placeholderLastName')}
                  onChange={OnChange}
                  value={state.lastNames}
                  variant="outlined"
                  style={{ width: '100%' }}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="start">
                        <Tooltip title="Apellidos del Usuario" arrow>
                          <InfoCircle size="20" color={palette.grayNew} />
                        </Tooltip>
                      </InputAdornment>
                    ),
                  }}
                />

                <label>{t('Email')}</label>
                <TextField
                  type="email"
                  name="email"
                  placeholder={t('placeholderEmail')}
                  onChange={OnChange}
                  value={state.email}
                  disabled={state?.iduserEdit}
                  variant="outlined"
                  style={{ width: '100%' }}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="start">
                        <Tooltip title="Email del Usuario" arrow>
                          <InfoCircle size="20" color={palette.grayNew} />
                        </Tooltip>
                      </InputAdornment>
                    ),
                  }}
                />

                <label>{t('Phone')}</label>
                <TextField
                  value={state.phoneNumber}
                  format="(###) ###-####"
                  mask="-"
                  placeholder="(238) 155-5180"
                  onChange={OnChange}
                  variant="outlined"
                  style={{ width: '100%' }}
                  name="phoneNumber"
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="start">
                        <Tooltip title="Teléfono" arrow>
                          <InfoCircle size="20" color={palette.grayNew} />
                        </Tooltip>
                      </InputAdornment>
                    ),
                  }}
                />

                {/* <label>{t('UserType')}</label> */}
                {/* <Autocomplete */}
                {/*  options={TypeUsers} */}
                {/*  getOptionLabel={(option) => option} */}
                {/*  value={TypeUsers[state.levelPermission]} */}
                {/*  name="type" */}
                {/*  onChange={(event, list) => */}
                {/*    setState((prev) => { */}
                {/*      let type; */}
                {/*      if (list === 'Admin' || list === 'admin') { */}
                {/*        type = 2; */}
                {/*      } else if ( */}
                {/*        list === 'Reclutador' || */}
                {/*        list === 'Recruiter' || */}
                {/*        list === 'reclutador' || */}
                {/*        list === 'recruiter' */}
                {/*      ) { */}
                {/*        type = 1; */}
                {/*      } else if (list === 'User' || list === 'Usuario' || list === 'usuario') { */}
                {/*        type = 0; */}
                {/*      } */}
                {/*      return { ...prev, levelPermission: type }; */}
                {/*    }) */}
                {/*  } */}
                {/*  className="cbx_persolnal" */}
                {/*  renderInput={(params) => <TextField {...params} variant="outlined" />} */}
                {/*  renderOption={(option) => { */}
                {/*    return ( */}
                {/*      <span style={{ fontSize: '14px', fontFamily: palette.nereg, textTransform: 'capitalize' }}> */}
                {/*        {option} */}
                {/*      </span> */}
                {/*    ); */}
                {/*  }} */}
                {/* /> */}
                {/* <p>{textData()}</p> */}
              </div>
            </div>
          </div>
        </section>
        <DialogActionsBar>
          <button
            type="button"
            onClick={() => {
              onClear();
              toggleModal();
            }}
            className="cancel">
            {t('addCancelTest')}
          </button>
          <button type="button" className="save" onClick={onSave}>
            {t('Accept')}
          </button>
        </DialogActionsBar>
      </Dialog>
    </MainContainer>
  );
};

ModalEditUser.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  user: PropTypes.object,
  toggleModal: PropTypes.func,
};

ModalEditUser.defaultProps = {
  user: {},
  toggleModal: () => {},
};

export default ModalEditUser;
